import angular from 'angular';

/* Helper directive to show bootstrap screensize in center of the screen
   Just add <bootstrap-size></bootstrap-size> to the page you are working on
*/
angular.module('cloudX').directive('bootstrapSize', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      scope: false,
      template: `<div class="bootstrapSize">
        <h1 class="visible-xs-inline">xs</h1>
        <h1 class="visible-sm-inline">sm</h1>
        <h1 class="visible-md-inline">md</h1>
        <h1 class="visible-lg-inline">lg</h1>
        </div>`,
    };
  },
]);
